import { create } from 'zustand';

export type ExecutionDrawer = 'alerts' | 'sla' | 'indicators' | 'history' | null;

interface ExecutionUIState {
  activeDrawer: ExecutionDrawer;
  showRiskOnly: boolean;

  openDrawer: (drawer: ExecutionDrawer) => void;
  closeDrawer: () => void;
  toggleDrawer: (drawer: NonNullable<ExecutionDrawer>) => void;
  toggleRiskOnly: () => void;
}

export const useExecutionUIStore = create<ExecutionUIState>((set, get) => ({
  activeDrawer: null,
  showRiskOnly: false,

  openDrawer: (drawer) => set({ activeDrawer: drawer }),
  closeDrawer: () => set({ activeDrawer: null }),
  toggleDrawer: (drawer) =>
    set({ activeDrawer: get().activeDrawer === drawer ? null : drawer }),
  toggleRiskOnly: () => set((s) => ({ showRiskOnly: !s.showRiskOnly })),
}));
